import { encode } from './lib/encode.js';
import { decode } from './lib/decode.js';
import {
  Token,
  Type
} from './lib/token.js';
export {
  decode,
  encode,
  Token,
  Type
};